import { gql } from '@apollo/client';

export const createRenderJob = gql`
    mutation CreateRenderingJob($input: RenderingJobInput!) {
        createRenderingJob(input: $input) {
            id
        }
    }
`;
